import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=6cab9f44"
import script from "./Shop.vue?vue&type=script&lang=ts"
export * from "./Shop.vue?vue&type=script&lang=ts"
import style0 from "./Shop.vue?vue&type=style&index=0&id=6cab9f44&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports